import startCase from 'lodash/startCase';

import { ArrowRightIcon } from '@change/ds-icons';

import { Chip, PetitionCard, Text } from '@change/ds-core-ui/next';

import { Translate, useI18n } from '@change-corgi/core/react/i18n';

import { useTrendingSectionSunrise } from './hooks/useTrendingSectionSunrise';

export function TrendingSectionSunrise() {
	const {
		actions,
		data: { shouldShowSection, shouldShowTopics, petitions, topics },
	} = useTrendingSectionSunrise();

	const { translate, translatePlural } = useI18n();

	if (!shouldShowSection) return null;

	return (
		<section
			className="text-typography-strong flex flex-col gap-6"
			aria-labelledby="sunrise-trending-section-title"
			data-testid="homepage-sunrise-trending-section"
		>
			<Text
				className="m-0"
				as="h2"
				id="sunrise-trending-section-title"
				data-qa="homepage-sunrise-trending-section-title"
				variant="heading"
				fontWeight="normal"
			>
				<Translate value="corgi.homepage.trending_section.title" />
			</Text>
			<Text variant="body" size="large">
				<Translate value="corgi.homepage.trending_section.description" />
			</Text>
			<div className="flex flex-wrap items-center gap-2" data-qa="sunrise-featured-topics">
				{shouldShowTopics &&
					topics.map((topic) => {
						return (
							<Chip
								data-testid="sunrise-topic-chip"
								data-qa="sunrise-topic-chip"
								key={topic.name}
								as="a"
								href={topic.slug}
								active={false}
								className="class-names"
								disabled={false}
								size="large"
								trailingIcon={<ArrowRightIcon />}
								onClick={() => actions.onTopicClick(topic.name)}
							>
								{startCase(topic.name)}
							</Chip>
						);
					})}
			</div>
			<div className="flex flex-col items-center gap-6">
				<div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
					{petitions.map((petition, index) => (
						<PetitionCard
							key={petition.id}
							className="petition-card"
							imageUrl={petition.photoUrl}
							location={petition.relevantLocationLocalizedName}
							petitionId={petition.id}
							petitionLinkOnClick={() =>
								actions.onPetitionCardClick({
									ask: petition.ask,
									petitionId: petition.id,
									signatureCount: petition.signatureCount,
									tags: petition.tagsConnection,
									cardPosition: index + 1,
									location: petition.relevantLocationLocalizedName,
								})
							}
							isVictory={petition.isVictory}
							victoryLabel={translate('corgi.components.petition_card.victory')}
							petitionLinkUrl={petition.slug}
							signaturesLabel={translatePlural('corgi.components.petition_card.signatures', petition.signatureCount, {
								countLocalized: petition.signatureCountLocalized,
							})}
							title={petition.ask}
						/>
					))}
				</div>
			</div>
		</section>
	);
}
